export default {
      id: "ic-nav-swiper-next1-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-swiper-next1-usage",
      toString: function () {
        return this.url;
      }
    }